import { render, staticRenderFns } from "./PointInfo.vue?vue&type=template&id=2b57e365&scoped=true&"
import script from "./PointInfo.vue?vue&type=script&lang=js&"
export * from "./PointInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57e365",
  null
  
)

export default component.exports